module.exports = __webpack_public_path__ + "media/images/s01_05-69cfa5d0b104083205eb88bcadadef14.svg";